import { CardContent, Checkbox, Grid } from '@mui/material';
import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Btn from '../../../Components/Ui_elements/Btn';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import { freelanceJobForInvoice } from '../../../redux/Thunk/FreelanceScreenThunk/FreelanceThunk';
import SearchField from '../../../Components/Ui_elements/SearchField';
import GenericTable from '../../../Components/Ui_elements/GenericTable';
import dayjs from 'dayjs';
import { freelanceInvoiceCreate } from '../../../redux/Thunk/ReportModule/ReportThunk';
import { JobSummeryResource } from '../../../redux/Thunk/ClientModule/ClientThunk';
import DropdownComponent from '../../../Components/DropdownComponent';
import { showSnackbar } from '../../../redux/Slice/snackbar/snackbarSlice';
import { localizeNumber } from '../../../Helper/generalhelper';
const FreelanceInvoiceJobs = () => {
    const { user } = useSelector((state) => state?.root?.authUser);
    const [selectedScoopIds, setSelectedScoopIds] = useState([]);
    const { get_invoice_generation } = useSelector((state) => state.root.FreelanceModule);
    const { job_summery_resource } = useSelector((state) => state.root.ClientModule);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({ resource_id: "" });


    useEffect(() => {
        if (user?.iFkUserTypeId === 1 && formData?.resource_id) {
            dispatch(freelanceJobForInvoice(formData?.resource_id))
        } else {
            dispatch(freelanceJobForInvoice(user?.iUserId))
        }
    }, [formData?.resource_id]);

    useEffect(() => {
        dispatch(JobSummeryResource())
    }, [])

    const jobResourceOptions = job_summery_resource?.map((resource) => ({
        value: resource.iUserId,
        label: `${resource.vUserName}`,
    }));

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'resource_id' && value === '') {
            // Reset states when resource_id is cleared
            setFormData({ resource_id: '' });
            setSelectedScoopIds([]);
        } else {
            // Update formData normally
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };


    const handleCheckboxChange = (job_summmeryId) => {
        setSelectedScoopIds((prevSelected) =>
            prevSelected.includes(job_summmeryId)
                ? prevSelected.filter((id) => id != job_summmeryId) // Remove if already selected
                : [...prevSelected, job_summmeryId] // Add if not selected
        );
    };

    const handleCreateInvoice = () => {
        if (selectedScoopIds?.length === 0) {
            dispatch(
                showSnackbar({
                    message: "Please select at least one Job",
                    type: "info",
                })
            );
            return
        }
        const payload = {
            user_id: user?.iFkUserTypeId == 2 ? user?.iUserId : formData?.resource_id,
            id: selectedScoopIds?.map(id => ({ id }))
        };

        dispatch(freelanceInvoiceCreate(payload)).then((response) => {
            navigate('/linguistinvoicecreate')
        });
    }

    const columns = [
        {
            name: "job_summmeryId",
            label: "#",
            options: {
                sortable: false,
                sort: false,
                customHeadLabelRender: () => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <Checkbox
                    checked={
                        selectedScoopIds.length > 0 &&
                        selectedScoopIds.length === get_invoice_generation?.length
                    }
                    indeterminate={
                        selectedScoopIds.length > 0 &&
                        selectedScoopIds.length < get_invoice_generation?.length
                    }
                    onChange={(e) => {
                        if (e.target.checked) {
                        const allScoopIds = get_invoice_generation?.map(item => item.job_summmeryId) || [];
                        setSelectedScoopIds(allScoopIds);
                        } else {
                        setSelectedScoopIds([]);
                        }
                    }}
                    />
                </div>
                ),
                customBodyRender: (_, tableMeta) => {
                    const job_summmeryId = tableMeta.rowData[0];
                    // const job_summmeryId = get_invoice_generation?.data?.data[tableMeta.rowIndex]?.job_summmeryId;
                    return (
                        <Checkbox
                            checked={selectedScoopIds.includes(job_summmeryId)}
                            onChange={() => handleCheckboxChange(job_summmeryId)}
                        />
                    );
                },
                setCellProps: () => ({ style: { width: "50px", textAlign: "center" } }),
            },
        },
        { name: "poNumber", label: "Job Number", },
        {
            name: "due_date",
            label: "Due Date",
            sortPramas: "due_date",
            options: {
                customBodyRender: (value) => {
                    if (value === "0000-00-00 00:00:00") {
                        return <Typography variant="body2"></Typography>;
                    }
                    const formattedDate = dayjs(value).format("DD.MM.YYYY");
                    const formattedTime = dayjs(value).format("HH:mm");
                    return (
                        <Typography variant="body2" noWrap>
                            {formattedDate} | {formattedTime}
                        </Typography>
                    );
                },
            },
        },

        { name: "item_status", label: "Status" },
        { name: "total_price", label: "Price", options: {
            customBodyRender: (value) => {
                    return (
                        <Typography variant="body2" noWrap>
                            {localizeNumber(value)}
                        </Typography>
                    );
                }
            } 
        },
        {
        name: "freelance_currency",
            label: "Currency",
            options: {
                customBodyRender: (value) => {
                    const currencyCode = value?.split(/[,|]/)[0] || ''; 
                    return (
                        <Typography variant="body2" noWrap>
                            {currencyCode}
                        </Typography>
                    );
                }
            }
        }
    ];

    return (
        <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h5" ml={2}>Invoice Create</Typography>
                <Grid item>
                    <Btn onClick={() => window.history.back()} startIcon={<ArrowBackIcon />}>
                        Back
                    </Btn>
                </Grid>
            </Box>
            <CardContent>
                <Box display="flex" alignItems="center" gap={2} mb={2} flexWrap="wrap">
                    {user?.iFkUserTypeId === 1 && <Box sx={{ minWidth: 300 }}>
                        <DropdownComponent
                            label="Select Linguist"
                            name="resource_id"
                            value={formData.resource_id}
                            onChange={handleInputChange}
                            options={jobResourceOptions}
                            isNotMandatory={true}
                        />
                    </Box>}
                    <Btn
                        sx={{ mr: 2, mt: 3 }}
                        onClick={handleCreateInvoice}
                        startIcon={<AddIcon />}
                    >
                        Create Invoice
                    </Btn>
                </Box>
                <GenericTable
                    columns={columns}
                    data={get_invoice_generation || []}
                    showAction={false}
                    displayColumns={4}
                    displayRows={10}
                />
            </CardContent>



        </>
    );
};

export default FreelanceInvoiceJobs;